/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendMessageRequest
 */
export interface SendMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof SendMessageRequest
     */
    content: string;
}

/**
 * Check if a given object implements the SendMessageRequest interface.
 */
export function instanceOfSendMessageRequest(value: object): value is SendMessageRequest {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function SendMessageRequestFromJSON(json: any): SendMessageRequest {
    return SendMessageRequestFromJSONTyped(json, false);
}

export function SendMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendMessageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function SendMessageRequestToJSON(json: any): SendMessageRequest {
    return SendMessageRequestToJSONTyped(json, false);
}

export function SendMessageRequestToJSONTyped(value?: SendMessageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
    };
}

